// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Avatar from 'material-ui/Avatar';
import {CardMedia} from 'material-ui/Card';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import AddIcon from 'material-ui/svg-icons/content/select-all';
import BlockIcon from 'material-ui/svg-icons/content/block';
import Chip from 'material-ui/Chip';
import {isIOS, isSafari, isMobile, isTablet, isBrowser} from 'react-device-detect';
import { EditorState, convertToRaw, ContentState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './styles.css';
import { colors, btn, card, form, breadcrumb, search as searchStyles } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg     = type === 'error' ? colors.dangerLt  : colors.successLt;
  const color  = type === 'error' ? colors.danger     : colors.success;
  const border = type === 'error' ? '#fca5a5'         : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: '1px solid ' + border, fontSize: 13,
    }}>
      <span style={{ color: color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

class EditTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      buddies: [],
      tournament: {
        id: "",
        name: "",
        venue: "",
        game_type: 13,
        start_date: moment(),
        end_date: moment(),
        age_groups: [],
        game_formats: [],
        category: 20,
        sub_category: "",
        registration_amount: '',
        registration_contact_number: '',
        description: EditorState.createEmpty(),
        format_desc: '',
        prize_and_perks: '',
        partners: '',
        _online_registration_enabled: false,
        pay_later: false,
        is_visible: false,
        mobile_no: '',
        organizers: [],
      },
      banner_list: {
        banner: '',
        banner_one: '',
        banner_two: '',
        banner_three: '',
      },
      add_second: false,
      add_third: false,
      add_fourth: false,
      search: false,
      search_loading: false,
      buddy_search_list: [],
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      categories: {},
      sub_categories: {},
      age_groups: [],
      game_formats: [],
      showDescriptionEditor: false,
      toast: null,
    };
    this.handleChange       = this.handleChange.bind(this);
    this.handleSubmit       = this.handleSubmit.bind(this);
    this.handleFile         = this.handleFile.bind(this);
    this.handleCheck        = this.handleCheck.bind(this);
    this.handleMultiselect  = this.handleMultiselect.bind(this);
    this.handleStartDate    = this.handleStartDate.bind(this);
    this.handleEndDate      = this.handleEndDate.bind(this);
    this.getSearchList      = this.getSearchList.bind(this);
    this.setSearch          = this.setSearch.bind(this);
    this.handledeleteBanner = this.handledeleteBanner.bind(this);

    this.chipStyle        = { margin: 4 };
    this.chipStyleGreen   = { margin: 4, backgroundColor: 'lightgreen' };
    this.chipWrapper      = { display: 'flex', flexWrap: 'wrap', gap: 4 };
  }

  componentDidMount() {
    this.get_details_for_edit_tournament();
  }

  showToast(message, type) {
    this.setState({ toast: { message: message, type: type || 'error' } });
  }

  get_details_for_edit_tournament() {
    const url = getLocationOrigin() + '/eagleeye/' + this.state.id + '/get_details_for_edit_tournament/';
    const options = { ...defaultOptions };
    fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        const gameTypes = data.game_type || [];
        const selectedGameType = gameTypes.find(gt => gt.pk === data.tournament.game_type);
        let newEditorState;
        try {
          if (data.tournament.description &&
              typeof data.tournament.description === 'object' &&
              data.tournament.description.blocks) {
            newEditorState = EditorState.createWithContent(convertFromRaw(data.tournament.description));
          } else if (typeof data.tournament.description === 'string' &&
                     data.tournament.description.trim() !== '') {
            const contentBlock = htmlToDraft(data.tournament.description);
            if (contentBlock) {
              newEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(contentBlock.contentBlocks));
            } else {
              newEditorState = EditorState.createEmpty();
            }
          } else {
            newEditorState = EditorState.createEmpty();
          }
        } catch (error) {
          console.error('Error parsing description:', error);
          newEditorState = EditorState.createEmpty();
        }

        this.setState({
          venues: data.venues,
          game_types: gameTypes,
          tournament: {
            ...data.tournament,
            game_type: selectedGameType || null,
            description: newEditorState,
          },
          age_groups: data.age_groups,
          game_formats: data.game_formats,
          tournament_series: data.tournament_series,
          forms: data.forms,
        }, () => this.setData());
      })
      .catch(error => console.error(error));
  }

  handleSeries(event) {
    if(event.target.value == '----Select----') { event.target.value = null; }
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['tournament_series'] = event.target.value;
    this.setState({ tournament: new_selected_one });
  }

  handleForm(event) {
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['form'] = event.target.value;
    this.setState({ tournament: new_selected_one });
  }

  handledeleteBanner(name) {
    var new_selected_one = Object.assign({}, this.state.tournament);
    if(name == 'banner')           { new_selected_one['banner'] = ''; }
    else if(name == 'banner_one')  { new_selected_one['banner_extra_1'] = ''; }
    else if(name == 'banner_two')  { new_selected_one['banner_extra_2'] = ''; }
    else                           { new_selected_one['banner_extra_3'] = ''; }
    this.setState({ tournament: new_selected_one });
  }

  setData() {
    var new_selected_one = Object.assign({}, this.state.tournament);
    var images = Object.assign({}, this.state.banner_list);
    new_selected_one['banner']         = this.state.tournament.banner;
    new_selected_one['banner_extra_1'] = this.state.tournament.banner_extra_1;
    new_selected_one['banner_extra_2'] = this.state.tournament.banner_extra_2;
    new_selected_one['banner_extra_3'] = this.state.tournament.banner_extra_3;
    images['banner']         = this.state.tournament.banner;
    images['banner_extra_1'] = this.state.tournament.banner_extra_1;
    images['banner_extra_2'] = this.state.tournament.banner_extra_2;
    images['banner_extra_3'] = this.state.tournament.banner_extra_3;
    this.setState({ tournament: new_selected_one, banner_list: images });
  }

  postEditedTournament(data, props) {
    var new_selected_one = Object.assign({}, data);
    new_selected_one['display_organizers'] = [...new Set(this.state.tournament.displayed_organizers.map(a => a.id))];
    this.setState({ tournament: new_selected_one }, () => {
      console.log("edit______________", this.state.tournament);
      const url = getLocationOrigin() + '/eagleeye/edit_tournament/';
      const options = { ...defaultOptions };
      var formData = new FormData();
      for (var name in this.state.tournament) {
        if (name === "game_type") {
          formData.append(name, this.state.tournament.game_type ? this.state.tournament.game_type.pk : "");
        } else if(name === 'description') {
          formData.append(name, this.getHtmlContent());
        } else {
          formData.append(name, this.state.tournament[name]);
        }
      }
      options['method'] = 'post';
      options['body'] = formData;
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus).then(parseJSON)
        .then(function(response) { alert(response.message); props.history.goBack(); })
        .catch(error => { console.log(error); alert(error.message); });
    });
  }

  getSearchList() {
    const term = this.state.mobile_no;
    if (!term || String(term).trim().length < 3) { this.showToast('Enter at least 3 characters to search'); return; }
    this.setState({ search_loading: true, toast: null });
    const url = getLocationOrigin() + '/eagleeye/search_buddy/';
    const options = { ...defaultOptions };
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'search': this.state.mobile_no });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        if (data.Message) {
          this.setState({ buddy_search_list: [], search: false, search_loading: false });
          this.showToast(data.Message);
          return;
        }
        this.setState({
          buddy_search_list: Array.isArray(data.results) ? data.results : [],
          search: true,
          search_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ buddy_search_list: [], search: false, search_loading: false });
        this.showToast(error && error.message ? error.message : 'Search failed. Please try again.');
      });
  }

  setSearch(name, buddy_id, mobile_no, event) {
    event.preventDefault();
    var new_selected_one = Object.assign({}, this.state.tournament);
    if(new_selected_one['organizers'] && new_selected_one['organizers'].includes(buddy_id)) {
      this.showToast('Coordinator already added');
      return false;
    } else {
      new_selected_one['organizers'].push(buddy_id);
      new_selected_one['organizer_list'].push({ 'id': buddy_id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png" });
      this.setState({ tournament: new_selected_one, search: false });
    }
  }

  handleRequestDelete = (key) => {
    var new_selected_one = Object.assign({}, this.state.tournament);
    const id_index = new_selected_one['organizers'].findIndex(buddy_id => buddy_id == key);
    new_selected_one['organizers'].splice(id_index, 1);
    const id_indexx = new_selected_one['organizer_list'].findIndex(buddy => buddy.id == key);
    new_selected_one['organizer_list'].splice(id_indexx, 1);
    this.setState({ tournament: new_selected_one });
  };

  handleDisplayDelete = (key) => {
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['display_organizers'] = [...new Set(this.state.tournament.displayed_organizers.map(a => a.id))];
    const id_indexx = new_selected_one['displayed_organizers'].findIndex(buddy => buddy.id == key);
    new_selected_one['displayed_organizers'].splice(id_indexx, 1);
    const id_index = new_selected_one['display_organizers'].findIndex(buddy_id => buddy_id == key);
    new_selected_one['display_organizers'].splice(id_index, 1);
    this.setState({ tournament: new_selected_one });
  };

  handleChip = (key) => {
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['display_organizers'] = [...new Set(this.state.tournament.displayed_organizers.map(a => a.id))];
    new_selected_one['display_organizers'].push(key.id);
    new_selected_one['displayed_organizers'].push(key);
    this.setState({ tournament: new_selected_one });
  };

  renderDisplayChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleDisplayDelete(data.id)} style={this.chipStyleGreen}>
        <Avatar id={data.id} src='http://www.sporthood.in/assets/img/avatar.png' />
        {data.name}
      </Chip>
    );
  }

  renderChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleRequestDelete(data.id)} onClick={() => this.handleChip(data)} style={this.chipStyle}>
        <Avatar id={data.id} src='http://www.sporthood.in/assets/img/avatar.png' />
        {data.name}
      </Chip>
    );
  }

  handleMultiselect(event) {
    console.log(event);
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one = Object.assign({}, this.state.tournament);
    var ids = [];
    if(event) {
      for (var i = 0, l = options.length; i < l; i++) {
        console.log(new_selected_one[name]);
        if (options[i].selected) { ids.push(options[i].value); }
      }
    }
    else {}
    new_selected_one[name] = ids;
    this.setState({ tournament: new_selected_one });
  }

  handleFile(event) {
    var name = event.target.name;
    var image = event.target.files[0];
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one[name] = image;
    var images = Object.assign({}, this.state.banner_list);
    images[name] = window.URL.createObjectURL(image);
    this.setState({ tournament: new_selected_one, banner_list: images });
  }

  handleChange(event) {
    const name = event.target.name;
    if(name == 'mobile_no') { this.setState({ mobile_no: event.target.value }); }
    else {
      var new_selected_one = Object.assign({}, this.state.tournament);
      new_selected_one[name] = event.target.value;
      this.setState({ tournament: new_selected_one });
    }
  }

  handleStartDate(date) {
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['start_date'] = moment(date);
    this.setState({ tournament: new_selected_one });
  }

  handleEndDate(date) {
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['end_date'] = (moment(date).subtract(5, 'hours')).subtract(30, 'minutes');
    this.setState({ tournament: new_selected_one });
  }

  handleVenue(event) {
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one['venue'] = event.target.value;
    this.setState({ tournament: new_selected_one });
  }

  handleCheck(event) {
    console.log(event.target.name + event.target.checked);
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.tournament);
    new_selected_one[name] = event.target.checked;
    this.setState({ tournament: new_selected_one });
  }

  goBack() { this.props.history.goBack(); }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.tournament.organizers) { this.postEditedTournament(this.state.tournament, this.props); }
    else { this.showToast('Please select a Coordinator'); }
  }

  handleGameType = (e) => {
    const selectedPk = parseInt(e.target.value, 10);
    const selectedGameType = this.state.game_types.find(gt => gt.pk === selectedPk);
    this.setState(prev => ({
      tournament: { ...prev.tournament, game_type: selectedGameType },
    }));
  };

  getHtmlContent = () => {
    const rawContentState = convertToRaw(this.state.tournament.description.getCurrentContent());
    return draftToHtml(rawContentState);
  };

  onEditorStateChange = (description) => {
    this.setState(prev => ({
      tournament: { ...prev.tournament, description: description },
    }));
  };

  // ── Banner slot renderer ──────────────────────────────────────────────────
  renderBannerSlot(label, bannerKey, extraKey) {
    const currentUrl = this.state.tournament[extraKey || bannerKey];
    const previewUrl = this.state.banner_list[extraKey || bannerKey] || this.state.banner_list[bannerKey];

    return (
      <div style={{
        flex: '1 1 160px', minWidth: 160,
        border: '1px solid ' + colors.border, borderRadius: 10,
        overflow: 'hidden', background: colors.bg,
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Preview area */}
        <div style={{ position: 'relative', width: '100%', paddingTop: '50%', background: colors.bg }}>
          {currentUrl ? (
            <div>
              <img
                src={previewUrl || currentUrl}
                alt={label}
                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
              <button
                type="button"
                style={{ position: 'absolute', top: 6, right: 6, width: 24, height: 24, borderRadius: '50%', background: 'rgba(224,36,36,0.9)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' }}
                onClick={() => this.handledeleteBanner(bannerKey)}
              >×</button>
            </div>
          ) : (
            <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
              <span style={{ fontSize: 22 }}>🖼️</span>
              <span style={{ fontSize: 10, color: colors.muted }}>Not uploaded</span>
            </div>
          )}
        </div>
        {/* Label + upload */}
        <div style={{ padding: '8px 10px' }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: colors.muted, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
          {!currentUrl && (
            <input
              type="file"
              name={extraKey || bannerKey}
              style={{ fontSize: 11, color: colors.text, width: '100%' }}
              onChange={(e) => this.handleFile(e)}
            />
          )}
        </div>
      </div>
    );
  }

  render() {
    console.log(this.state.tournament);
    const { tournament, search, search_loading, buddy_search_list, toast } = this.state;

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: colors.bg, minHeight: '100vh', boxSizing: 'border-box' }}>

        {/* Breadcrumb */}
        <div style={breadcrumb.wrap}>
          <a href={'/#/partnerTournament'} style={breadcrumb.link}>Events</a>
          <span style={breadcrumb.separator}>›</span>
          <a href={'/#/crud/viewTournament/' + tournament.id} style={breadcrumb.link}>{tournament.name}</a>
          <span style={breadcrumb.separator}>›</span>
          <span style={breadcrumb.current}>Edit</span>
        </div>

        <div style={{ padding: '0 20px 40px' }}>
          <div style={{ maxWidth: 720, margin: '0 auto' }}>
            <div style={{ background: colors.surface, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: '1px solid ' + colors.border }}>
                <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>Edit Tournament</h2>
              </div>

              <div style={{ padding: '20px 24px' }}>
                <Toast message={toast && toast.message} type={toast && toast.type} onClose={() => this.setState({ toast: null })} />

                <form className="validated-form form-horizontal">

                  {/* Tournament Name */}
                  <div style={form.row}>
                    <div style={form.labelWide}>Tournament Name</div>
                    <input type="text" style={form.input} name="name" value={tournament.name} onChange={this.handleChange} />
                  </div>

                  {/* Venue */}
                  <div style={form.row}>
                    <div style={form.labelWide}>Venue</div>
                    <select name="venue" style={form.select} value={tournament.venue} onChange={(e) => { this.handleVenue(e); }}>
                      {Object.keys(this.state.venues).map((key, index) => (
                        <option key={index} value={this.state.venues[key].id}>{this.state.venues[key].name}</option>
                      ))}
                    </select>
                  </div>

                  {/* Start Date */}
                  <div style={form.row}>
                    <div style={form.labelWide}>Start Date</div>
                    <div style={{ zIndex: 99 }}>
                      <DatePicker selected={moment(tournament.start_date)} onChange={this.handleStartDate} />
                    </div>
                  </div>

                  {/* End Date */}
                  <div style={form.row}>
                    <div style={form.labelWide}>End Date</div>
                    <div style={{ zIndex: 9 }}>
                      <DatePicker selected={moment(tournament.end_date)} onChange={this.handleEndDate} />
                    </div>
                  </div>

                  {/* Game Type */}
                  <div style={form.row}>
                    <div style={form.labelWide}>Game Type</div>
                    <select
                      name="game_type"
                      style={form.select}
                      value={tournament.game_type && tournament.game_type.pk ? tournament.game_type.pk : ""}
                      onChange={this.handleGameType}
                    >
                      {this.state.game_types.map(gt => (
                        <option key={gt.pk} value={gt.pk}>{gt.game} {gt.name}</option>
                      ))}
                    </select>
                  </div>

                  {/* Description — rich text editor */}
                  <div style={{ ...form.row, alignItems: 'flex-start' }}>
                    <div style={form.labelWide}>Description</div>
                    <div style={{ flex: 1 }}>
                      {/*<textarea rows="4" cols="33" style={styles.input} name="description" value={this.state.tournament.description}
                        onChange={this.handleChange}>
                        {this.state.tournament.description}
                      </textarea>*/}
                      {!this.state.showDescriptionEditor ? (
                        <div style={{ border: '1px solid ' + colors.border, borderRadius: 8, overflow: 'hidden' }}>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 12px', borderBottom: '1px solid ' + colors.border, background: colors.bg }}>
                            <button
                              type="button"
                              style={{ ...btn.outlineSm, display: 'flex', alignItems: 'center', gap: 6 }}
                              onClick={() => this.setState(prevState => ({ showDescriptionEditor: !prevState.showDescriptionEditor }))}
                            >
                              <i className="fa fa-pencil" /> Edit
                            </button>
                          </div>
                          <div style={{ padding: '12px 16px', fontSize: 13, color: colors.text, lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: this.getHtmlContent() }} />
                        </div>
                      ) : (
                        <div style={{ border: '1px solid ' + colors.border, borderRadius: 8, overflow: 'hidden' }}>
                          <Editor
                            editorState={tournament.description}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={this.onEditorStateChange}
                            doExpand={true}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Coordinator search */}
                  <div style={form.row}>
                    <div style={form.labelWide}>Coordinator</div>
                    <div style={form.searchWrap}>
                      <input
                        type="text"
                        name="mobile_no"
                        placeholder="Search (min 3 chars)…"
                        style={form.searchInput}
                        value={this.state.mobile_no || ''}
                        onChange={this.handleChange}
                        onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), this.getSearchList())}
                      />
                      <button
                        type="button"
                        style={{ ...form.searchBtn, opacity: search_loading ? 0.6 : 1 }}
                        onClick={this.getSearchList}
                        disabled={search_loading}
                      >
                        {search_loading ? '…' : '🔍'}
                      </button>
                    </div>
                  </div>

                  {/* Search results */}
                  {search && (
                    <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                      {buddy_search_list.length ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                          {buddy_search_list.map(x => (
                            <button
                              key={x.mobile_no + x.name}
                              type="button"
                              style={{ ...btn.outline, fontSize: 12, padding: '6px 12px' }}
                              onClick={(e) => this.setSearch(x.name, x.id, x.mobile_no, e)}
                            >
                              {x.name}: {x.mobile_no}
                            </button>
                          ))}
                        </div>
                      ) : (
                        <div style={searchStyles.notFound}>
                          <span style={searchStyles.notFoundText}>Search customer not found</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Selected Coordinators */}
                  {tournament.organizer_list && tournament.organizer_list.length > 0 && (
                    <div style={form.row}>
                      <div style={form.labelWide}>Selected Coordinator(s)</div>
                      <div style={this.chipWrapper}>
                        {tournament.organizer_list.map(this.renderChip, this)}
                      </div>
                    </div>
                  )}

                  {/* Displayed Coordinators */}
                  {tournament.displayed_organizers && tournament.displayed_organizers.length > 0 && (
                    <div style={form.row}>
                      <div style={form.labelWide}>Displayed Coordinator(s)</div>
                      <div style={this.chipWrapper}>
                        {tournament.displayed_organizers.map(this.renderDisplayChip, this)}
                      </div>
                    </div>
                  )}

                  {/* Banners */}
                  <div style={{ ...form.row, alignItems: 'flex-start' }}>
                    <div style={form.labelWide}>
                      Banners
                      <div style={{ fontSize: 11, color: colors.danger, fontWeight: 500, marginTop: 2 }}>Upload 2×1 images</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                      {this.renderBannerSlot('Banner 1', 'banner',         null)}
                      {this.renderBannerSlot('Banner 2', 'banner_one',    'banner_extra_1')}
                      {this.renderBannerSlot('Banner 3', 'banner_two',    'banner_extra_2')}
                      {this.renderBannerSlot('Banner 4', 'banner_three',  'banner_extra_3')}
                    </div>
                  </div>

                  {/* Tournament Series */}
                  {this.state.tournament_series && (
                    <div style={form.row}>
                      <div style={form.labelWide}>Tournament Series</div>
                      <select name="edition" style={form.select} value={tournament.tournament_series} onChange={(e) => { this.handleSeries(e); }}>
                        <option key={-1} value={null}>----Select----</option>
                        {Object.keys(this.state.tournament_series).map((key, index) => (
                          <option key={index} value={this.state.tournament_series[key].id}>{this.state.tournament_series[key].name}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Form */}
                  {this.state.forms && (
                    <div style={form.row}>
                      <div style={form.labelWide}>Form</div>
                      <select name="form" style={form.select} value={tournament.form} onChange={(e) => { this.handleForm(e); }}>
                        <option value=''>----Select----</option>
                        {this.state.forms && this.state.forms.length > 0 && this.state.forms.map((f, index) => (
                          <option key={index} value={f.id}>{f.name}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* ── Toggle checkboxes ── */}
                  <div style={{ borderTop: '1px solid ' + colors.border, paddingTop: 16, marginTop: 8, display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {[
                      { name: 'is_promoted',                   label: 'Is Promoted Event' },
                      { name: '_online_registration_enabled',  label: 'Online Registration' },
                      { name: 'pay_later',                     label: 'Free Event' },
                      { name: 'is_visible',                    label: 'Publish' },
                    ].map(item => (
                      <label key={item.name} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, color: colors.text, fontWeight: 500 }}>
                        <input
                          type="checkbox"
                          name={item.name}
                          checked={tournament[item.name] || false}
                          onChange={this.handleCheck}
                          style={{ width: 16, height: 16, cursor: 'pointer', accentColor: colors.brand }}
                        />
                        {item.label}
                      </label>
                    ))}
                  </div>

                  {/* Success / error messages */}
                  {this.state.data_uploaded && (
                    <div style={{ marginTop: 12, fontSize: 13, color: colors.success, fontWeight: 600 }}>✓ Fixture created successfully.</div>
                  )}
                  {this.state.data_error && (
                    <div style={{ marginTop: 12, fontSize: 13, color: colors.danger, fontWeight: 600 }}>✕ Error, creation failed.</div>
                  )}

                  {/* Footer buttons */}
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 20, borderTop: '1px solid ' + colors.border, marginTop: 20 }}>
                    <button type="button" style={btn.cancel} onClick={() => { this.goBack(); }}>Cancel</button>
                    <button type="button" style={btn.primary} onClick={(e) => { this.handleSubmit(e); }}>Save Changes</button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default EditTournament;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTournament/index.js